import classNames from 'classnames';

import { useMapCardStyles } from './MapCard.styles';

export function MapCard({ className, children }) {
  const { styles } = useMapCardStyles();
  return (
    <div className={classNames('MapCard', styles.mapCard, className)}>
      {children}
    </div>
  );
}
